import { styled } from "../../../../../../styles";

export const StagesChartWrapper = styled("div", {
  position: "relative",
  width: "100%",
});
